<template>
  <div v-if="item!=null" class="ui segment previewItem certainty_padding">
    <div v-if="item.hasOwnProperty('cert')" class="certainty" v-bind:class="{same_as:item.cert=='same_as',high:item.cert=='high',medium:item.cert=='medium',low:item.cert=='low'}">Certainity of concordance: {{item.cert}}</div>
    <div class="certainty"><span  style="position:absolute;font-weight: bold;right:5px">{{item.xml_id}}</span></div>
    <span v-if="item.hasOwnProperty('name')">
        <span v-if="hasOwnDeepProperty(item, 'src.value')">
            <span v-if="item.src.value=='copy'">
                <span v-if="personas.hasOwnProperty('copist')">
                    <!--<router-link :to='{ name: "search", query: { query: "\""+personas.copist+"\"" } }'>{{personas.copist}}</router-link></span>-->
                 {{personas.copist}}</span>
                <span style="font-weight:normal; font-style: italic;">(copy after
                    <span v-if="personas.hasOwnProperty('artist')" >{{personas.artist}})<br></span>
                    <span v-else>)<br></span>
                </span>
            </span>
            <span v-else>{{personas.artist}}<br></span>
        </span>
         <span v-else>{{personas.artist}}<br></span>
    </span>
    <span class="italic">{{item.original_inventory_id}}<span v-if="item.hasOwnProperty('original_inventory_id_letter')">{{item.original_inventory_id_letter}}</span> <span v-html="item.text"></span></span><br><br>
    <span v-if="item.hasOwnProperty('room')" style="word-wrap: normal;">
        <span class="">Room:</span><br>
        
        <span class="italic" style="cursor:pointer" v-on:click="searchName(item.room.original_description)">{{item.room.original_description}}</span><br>
        <span v-if="item.hasOwnProperty('place')">
            <span class="">Place:</span><br>
            <span class="italic"  style="cursor:pointer" v-on:click="searchName(item.place.original_description)">{{item.place.original_description}}</span>
        </span>
    </span>
</div>

</template>

<script>
    export default {
        props: ['item'],
        data() {
            return {
                //  item: null
                item_with_overstrike: "",
                person: "",
                personas: {}
            }
        },

        methods: {

            personName: function() {
                var ret = "";
                var role = "artist"
                for (var i in this.item.name) {
                    if (this.item.name[i].hasOwnProperty('role')) {
                        role = this.item.name[i].role;
                    }
                    if (this.item.name[i].hasOwnProperty('getty_data')) {
                        this.personas[role] = this.item.name[i].getty_data.display_name;
                    }
                    else {
                        this.personas[role] = this.item.name[i].value;
                    }
                }
            },
            hasOwnDeepProperty: function(obj, path) {
                var arr;
                for (var i = 0, path = path.split('.'), len = path.length; i < len; i++) {
                    arr = path[i].match(/(.+)\[(\d+)\]/mi);
                    if (arr != null) {
                        if (arr.length == 3) {
                            if (obj[arr[1]]) obj = obj[arr[1]][arr[2]];
                            else return false;
                        }
                    }
                    else obj = obj[path[i]];
                    if (!obj) return false;
                };
                return true;
            },
        },

        mounted() {
            if (this.item.hasOwnProperty('overstrike')) {
                var rgx = new RegExp(this.item.overstrike, "i");
                this.item.text = this.item.text.replace(rgx, function(str) {
                    return "<span style='text-decoration: line-through;'>" + str + "</span>";
                });
            }
        },
        created() {
            this.personName();
        },

        components: {

        },
    }
</script>

<style scoped>
    .italic {
        font-style: italic;
    }

    .copist {
        color: #595959;
    }

    .previewItem {
        width: 450px;
        white-space: normal;
        line-height:1.2;
    }
    
    .certainty{
        position:absolute;
        top:0px;
        left:0px;
        width:100%;
        padding: 0.5em 1em;
    }
    
    .certainty_padding{
        padding-top:3em;
    }
    
     .same_as {
    background-color: #3399ff;
  }

  .high {
    background-color: rgb(174, 223, 181)
  }

  .medium {
    background-color: rgb(255, 216, 179)
  }

  .low {
    background-color: #FFAAAA
  }
</style>



// WEBPACK FOOTER //
// src/components/ThePreview.vue